import React from 'react';
import { Box, Card, CardContent, CircularProgress, Grid, Typography } from '@mui/material';
import { InfoTooltip } from '../Tooltips';
import { COLOR_TOOLTIP_BACKGROUND } from 'src/const';
import { formatCurrencyBasedOnCountryCode } from 'src/utils/functions';

export const MapListingCountInfoBox = ({
  listingsLength,
  otaListingsLength,
  isMapChanging,
}: {
  listingsLength: number;
  otaListingsLength: number;
  isMapChanging: boolean;
}) => {
  return (
    <Box
      sx={{
        marginRight: '10px',
        background: '#0008',
        borderRadius: 4,
        padding: '5px 10px',
        position: 'absolute',
        top: '7px',
        left: '7px',
        zIndex: 3,
        backdropFilter: 'blur(4px)',
        height: '20px',
        overflow: 'hidden',
        transition: 'height 0.25s ease, border-radius 0.25s ease',
        '&:hover': {
          height: '42px',
          borderRadius: 2,
        },
      }}
    >
      <Typography variant="body2" style={{ color: '#fff' }}>
        <div>
          {isMapChanging ? (
            <CircularProgress size={10} color={'inherit'} thickness={10} />
          ) : (
            formatCurrencyBasedOnCountryCode(listingsLength, 'USD')
          )}{' '}
          Airbnb listings are available in this area
        </div>
      </Typography>

      <Typography variant="body2" style={{ color: '#fff', marginTop: '2px' }}>
        <div>
          {isMapChanging ? (
            <CircularProgress size={10} color={'inherit'} thickness={10} />
          ) : (
            formatCurrencyBasedOnCountryCode(otaListingsLength, 'USD')
          )}{' '}
          VRBO, Booking.com, and Tripadvisor listings are available in this area
        </div>
      </Typography>
    </Box>
  );
};
